import { useState } from "react";
import { Grid, TextField } from "@mui/material";
import styles from "./styles.module.css";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import { STORAGE_KEYS, DEFAULT_BATCH_BARCODE_CONFIG } from "const";
import { toast } from "react-hot-toast";

function BatchBarcodeConfig() {
  const [batchBarcodeConfig, setBatchBarcodeConfig] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEYS.BATCH_BARCODE_CONFIG);
    if (stored) return JSON.parse(stored);
    return {
      pluLength: DEFAULT_BATCH_BARCODE_CONFIG.PLU_LEN,
      weightLength: DEFAULT_BATCH_BARCODE_CONFIG.WEIGHT_LEN,
      priceLength: DEFAULT_BATCH_BARCODE_CONFIG.PRICE_LEN,
    };
  });

  const handleSaveBatchConfig = () => {
    localStorage.setItem(STORAGE_KEYS.BATCH_BARCODE_CONFIG, JSON.stringify(batchBarcodeConfig));
    toast.success("Batch barcode configuration saved");
  };

  return (
    <div className={styles.container}>
      <div className={styles.scrollableArea}>
        <Grid style={{ width: "100%" }}>
          <Grid item xs={12} className={styles.sectionWrapper}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  fullWidth
                  label="Batch code PLU length"
                  type="number"
                  value={batchBarcodeConfig.pluLength}
                  onChange={(e) => setBatchBarcodeConfig({ ...batchBarcodeConfig, pluLength: Number(e.target.value) })}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  fullWidth
                  label="Batch code weight length"
                  type="number"
                  value={batchBarcodeConfig.weightLength}
                  onChange={(e) =>
                    setBatchBarcodeConfig({ ...batchBarcodeConfig, weightLength: Number(e.target.value) })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  fullWidth
                  label="Batch code price length"
                  type="number"
                  value={batchBarcodeConfig.priceLength}
                  onChange={(e) =>
                    setBatchBarcodeConfig({ ...batchBarcodeConfig, priceLength: Number(e.target.value) })
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" }}
              >
                <ButtonRed onClick={handleSaveBatchConfig}>Save</ButtonRed>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default BatchBarcodeConfig;
